<template>
  <div
    class="row border border-azul-claro2 mx-0 text-azul mt-3 mb-5 postulante1"
    v-if="postulacion"
  >
    <div
      class="col-12 col-sm-8 col-lg-4 d-flex align-items-center text-left pt-3 pb-0 pb-sm-3"
    >
      <div class="col-3 px-0">
        <img
          v-if="postulacion.postulante.sexo == 'M'"
          src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/icono-hijo.png"
          class="img-fluid"
          alt
        />
        <img
          v-else
          src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/icono-hija.png"
          class="img-fluid"
          alt
        />
      </div>
      <div class="pl-3">
        <div class="gilmer text-uppercase">Postulante</div>
        <div class="font-weight-bold">
          {{ postulacion.postulante.nombres }}
          {{ postulacion.postulante.paterno }}
          {{ postulacion.postulante.materno }}
        </div>
      </div>
    </div>
    <div
      class="col-auto w-1px border-left border-azul-claro2 d-none d-sm-block px-0"
    ></div>
    <div
      class="col-12 col-sm col-lg text-center pt-1 pt-sm-2 pb-2 d-flex align-items-center"
    >
      <div class="col-3 px-0 d-block d-sm-none"></div>
      <div class="mx-auto px-auto col-9 col-sm text-left text-sm-center">
        <div class="d-inline-block d-sm-block gilmer text-uppercase">Curso</div>
        <div class="d-inline-block d-sm-block font-weight-bold">
          {{ postulacion.postulante.glosaNivel }}
        </div>
      </div>
    </div>
    <div
      class="col-auto w-1px border-left border-azul-claro2 d-none d-lg-block px-0"
    ></div>
    <div
      class="col-12 h-1px border-top border-azul-claro2 d-block d-lg-none px-0"
    ></div>
    <div
      class="col text-black-50 py-3 d-flex align-items-center justify-content-center"
    >
      <div class="text-center">
        <div class="d-block">Fecha y hora postulación:</div>
        <div class="d-block">{{ postulacion.fechaModificacion }}</div>
        <a
          href="#"
          class="btn btn-azul-oscuro2 mt-2 gilmer text-uppercase"
          @click.prevent="descargarComprobante"
        >
          Descargar comprobante
          <FontAwesomeIcon icon="check" class="mr-2" />
        </a>
      </div>
    </div>
    <div
      class="col-auto w-1px border-left border-azul-claro2 d-none d-lg-block px-0"
    ></div>
    <b-col
      cols="12"
      class="border-top border-azul-claro2 py-3 px-2 text-center text-dark bg-light"
    >
      <FontAwesomeIcon icon="check" class="mr-2 text-success" />
      <strong>Última postulación válida</strong>
      <span class="d-inline-block d-lg-inline"
        >correspondiente al período
        <strong>{{
          postulacion.periodo == 1 ? "principal" : "complementario"
        }}</strong></span
      >
    </b-col>
  </div>
</template>
<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBell,
  faCheckDouble,
  faTrashAlt,
  faThumbsUp,
  faEye,
  faPencilAlt,
  faDownload,
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { MensajesDeCarga } from "@/utils/BusesDeEventos.js";
library.add(
  faBell,
  faCheckDouble,
  faTrashAlt,
  faThumbsUp,
  faEye,
  faPencilAlt,
  faDownload,
  faCheck
);
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    postulacion: {
      required: true
    }
  },
  methods: {
    descargarComprobante() {
      this.$gtag.event("descargar-comprobante-postulacion", {
        event_category: "postulacion",
        event_label: "descargar-comprobante-postulacion-listado-postulantes",
        value: ""
      });
      window.open(
        PLATAFORMA.COMPROBANTE +
          "descargar-comprobante?postulacion=" +
          this.postulacion.validacion,
        "_blank"
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/postulante/ItemPostulacion.vue